var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('img',{staticClass:"IFLOFO",attrs:{"src":_vm.logoSrc}}),_c('h2',[_vm._v("云天励飞会议预定系统")])])}
var staticRenderFns = []

export { render, staticRenderFns }